import { render, staticRenderFns } from "./ImageMask.vue?vue&type=template&id=10a0ed20&scoped=true&comments=true&"
import script from "./ImageMask.vue?vue&type=script&lang=js&"
export * from "./ImageMask.vue?vue&type=script&lang=js&"
import style0 from "./ImageMask.vue?vue&type=style&index=0&id=10a0ed20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a0ed20",
  null
  
)

export default component.exports